<template>
  <div class="drawer-wrapper">
    <el-drawer :wrapperClosable="true" :title="title" :visible.sync="AddContractFlag" size="50%"
               :before-close="AddNone" direction="rtl">

      <div class="demo-drawer__content">
        <el-form :model="addForm" :rules="rules" ref="ruleForm">
          <el-row :gutter="35">

            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="合同编号" prop="code" :label-width="formLabelWidth">
                <el-input v-model="addForm.code" placeholder="请输入合同编号" clearable style="width: 85%;"></el-input>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="合同名称" prop="name" :label-width="formLabelWidth">
                <el-input v-model="addForm.name" placeholder="请输入合同名称" clearable style="width: 85%;"></el-input>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="甲方主体公司" prop="a_subject_id" :label-width="formLabelWidth">
                <div style="display: flex;">
                  <SelectChecked  ref="SelectChecked1" :options="subjectListA" :isRemoveAllTag="isRemoveAllTag" placeholder="请选择甲方主体公司"
                    @selectedVal="selectedReferralA" style="width: 85%;" />
                  <img @click="AddPushSubjec"
                    style="width: 25px;height: 25px;margin-left:10px;margin-top:5px;cursor: pointer;"
                    src="@/assets/btn/xinzeng.png" alt="">
                  <img @click="AddRefreshSubjec"
                  style="width: 25px;height: 25px;margin-left:10px;margin-top:5px;cursor: pointer;"
                  src="@/assets/btn/shuaxin.png" alt="">
                </div>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="乙方主体公司" prop="b_subject_id" :label-width="formLabelWidth">
                <div style="display: flex;">
                  <SelectChecked  ref="SelectChecked2" :isRemoveAllTag="isRemoveAllTag" :options="subjectListB" placeholder="请选择乙方主体公司"
                    @selectedVal="selectedReferralB" style="width: 85%;"></SelectChecked>
                  <img @click="AddPushSubjec"
                    style="width: 25px;height: 25px;margin-left:10px;margin-top:5px;cursor: pointer;"
                    src="@/assets/btn/xinzeng.png" alt="">
                  <img @click="AddRefreshSubjec"
                  style="width: 25px;height: 25px;margin-left:10px;margin-top:5px;cursor: pointer;"
                  src="@/assets/btn/shuaxin.png" alt="">
                </div>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="上传合同" prop="uploadFile" :label-width="formLabelWidth">
                <el-upload
                    style="width:85%"
                    class="upload-demo"
                    action
                    :http-request="(file) => httpRequest(file)"
                    :on-preview="handlePreview"
                    :on-remove="handleRemove"
                    :before-remove="beforeRemove"
                    :multiple=false
                    :limit="myLimit"
                    :on-exceed="handleExceed"
                    :before-upload="beforeAvatarUpload"
                    accept=".pdf"
                    :file-list="fileList">
                  <el-button size="small" type="primary">点击上传</el-button>
                  <div slot="tip" class="el-upload__tip">只能上传pdf文件，且不超过100MB</div>
                </el-upload>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
                <el-form-item label="授权范围" prop="licensing_area" :label-width="formLabelWidth">
                    <el-select v-model="addForm.licensing_area" placeholder="请选择授权范围" clearable style="width: 85%;">
                        <el-option v-for="area in licensingAreaList" :key="area.id" :label="area.name" :value="area.id"></el-option>
                    </el-select>
                </el-form-item>
            </el-col>

            <el-col v-if="addForm.licensing_area" :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="授权范围描述" prop="licensing_area_describe" :label-width="formLabelWidth">
                <el-input type="textarea"  v-model="addForm.licensing_area_describe" autosize placeholder="请输入授权范围描述" clearable style="width: 85%;"></el-input>
              </el-form-item>
            </el-col>
            
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="合同类型" prop="type" :label-width="formLabelWidth">
                <el-select v-model="addForm.type" filterable :disabled="title=='编辑'" placeholder="合同类型 【保存后不支持修改】" style="width: 85%" @change="typeChange">
                  <el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
                </el-select>
                <el-row v-if="addForm.type" :gutter="24" style="margin-top: 20px;" class="child">
                  <el-col  v-if="currentTypeList.includes('short_play_project_id')" :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
                    <el-form-item label="小说项目名称" prop="short_play_project_id" :label-width="formLabelWidthChild"
                      :rules="[{required: true, message: '', trigger: 'blur', validator: validateProject}]"
                    >
                      <div style="display: flex;">
                          <el-autocomplete
                            v-model="project_name"
                            style="width: 85%;"
                            :fetch-suggestions="querySearch"
                            clearable
                            placeholder="请选择项目（可输入关键字搜索）"
                            @select="handleSelect"
                          >
                          <template slot-scope="{ item }">
                            <div>{{ item.name }}</div>
                          </template>
                        </el-autocomplete>
                        <img @click="AddPushSubjec('pro')"
                          style="width: 25px;height: 25px;margin-left:10px;margin-top:5px;cursor: pointer;"
                          src="@/assets/btn/xinzeng.png" alt="">
                        <img @click="getProjectSelect"
                        style="width: 25px;height: 25px;margin-left:10px;margin-top:5px;cursor: pointer;"
                        src="@/assets/btn/shuaxin.png" alt="">
                      </div>
                    </el-form-item>
                  </el-col>
                  <el-col v-if="currentTypeList.includes('authorize_object')" :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
                      <el-form-item label="分销类型" prop="authorize_object" :label-width="formLabelWidthChild">
                          <el-select v-model="addForm.authorize_object" placeholder="请选择分销类型" clearable style="width: 100%;">
                              <el-option label="分销我方剧目" :value="1"></el-option>
                              <el-option label="分销对方剧目" :value="2"></el-option>
                          </el-select>
                      </el-form-item>
                  </el-col>
                  <el-col v-if="currentTypeList.includes('amount')" :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
                      <el-form-item  :label="amountName" prop="amount" :label-width="formLabelWidthChild" >
                          <el-input v-model="addForm.amount"  :placeholder="'请输入'+amountName" clearable 
                            oninput="this.value=this.value.replace(/[^\d.]/g,'').replace(/(\.\d+)\.+/g, '$1').replace(/(\..*)\./g, '$1').replace(/(\.\d{2})\d+/g, '$1')"
                          ></el-input>
                      </el-form-item>
                  </el-col>
                  <el-col v-if="currentTypeList.includes('real_amount')" :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
                      <el-form-item :label="addForm.type == 6 ? '实际投资金额' : '实际支出成本'" :label-width="formLabelWidthChild">
                          <el-input v-model="addForm.real_amount"  :placeholder="`请输入${addForm.type == 6 ? '实际投资金额' : '实际支出成本'}`"
                          oninput="this.value=this.value.replace(/[^\d.]/g,'').replace(/(\.\d+)\.+/g, '$1').replace(/(\..*)\./g, '$1').replace(/(\.\d{2})\d+/g, '$1')"
                          clearable></el-input>
                      </el-form-item>
                  </el-col>
                  <el-col v-if="currentTypeList.includes('initial_amount')" :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
                      <el-form-item label="首款" :label-width="formLabelWidthChild">
                          <el-input v-model="addForm.initial_amount"  placeholder="请输入首款"
                          oninput="this.value=this.value.replace(/[^\d.]/g,'').replace(/(\.\d+)\.+/g, '$1').replace(/(\..*)\./g, '$1').replace(/(\.\d{2})\d+/g, '$1')"
                          clearable></el-input>
                      </el-form-item>
                  </el-col>
                  <el-col v-if="currentTypeList.includes('middle_amount')" :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
                      <el-form-item label="杀青款" :label-width="formLabelWidthChild">
                          <el-input v-model="addForm.middle_amount"  placeholder="请输入杀青款"
                          oninput="this.value=this.value.replace(/[^\d.]/g,'').replace(/(\.\d+)\.+/g, '$1').replace(/(\..*)\./g, '$1').replace(/(\.\d{2})\d+/g, '$1')"
                          clearable></el-input>
                      </el-form-item>
                  </el-col>
                  <el-col v-if="currentTypeList.includes('final_amount')" :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
                      <el-form-item label="尾款" :label-width="formLabelWidthChild">
                          <el-input v-model="addForm.final_amount"  placeholder="请输入尾款"
                          oninput="this.value=this.value.replace(/[^\d.]/g,'').replace(/(\.\d+)\.+/g, '$1').replace(/(\..*)\./g, '$1').replace(/(\.\d{2})\d+/g, '$1')"
                          clearable></el-input>
                      </el-form-item>
                  </el-col>
                  <el-col  v-if="currentTypeList.includes('is_divided')" :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
                      <el-form-item label="是否涉及分成" prop="is_divided" :label-width="formLabelWidthChild">
                          <el-radio-group v-model="addForm.is_divided">
                            <el-radio :label="1">是</el-radio>
                            <el-radio :label="0">否</el-radio>
                          </el-radio-group>
                      </el-form-item>
                  </el-col>
                  <el-col v-if="currentTypeList.includes('divided_type') && addForm.is_divided == 1" :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
                      <el-form-item label="分成类型" prop="divided_type" :label-width="formLabelWidthChild"
                      :rules="[
                          {required: currentTypeList.includes('divided_type') && addForm.is_divided==1, message: '请选择分成类型', trigger: 'change'}
                        ]">
                          <el-select v-model="addForm.divided_type" placeholder="请选择分成类型" style="width: 100%;" @change="handleChangeChildType">
                              <el-option label="投流分成" :value="1"></el-option>
                              <el-option label="平台分成" :value="2"></el-option>
                          </el-select>
                      </el-form-item>
                  </el-col>
                  <template  v-if="currentTypeList.includes('platformArray') && addForm.is_divided == 1">
                    <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20" 
                      v-for="(item, index) in addForm.platformArray" :key="index">
                      <div style="display: flex;height: 41px;">
                        <el-form-item label="平台名称" :prop="'platformArray.' + index + '.platform_name'"  :label-width="formLabelWidthChild" style="width:40%" 
                          :rules="[{ required: currentTypeList.includes('platformArray'), message: '', trigger: 'chablurnge', validator: validatePlatForm }]">
                          <el-input v-model="item.platform_name" placeholder="请输入平台名称" clearable style="width: 90%;"></el-input>
                        </el-form-item>
                        <el-form-item label="分成比例" :label-width="'80px'" :prop="'platformArray.' + index + '.platform_rate'" style="width:40%" 
                          :rules="[{ required: currentTypeList.includes('platformArray'), message: '', trigger: 'blur', validator: validateDivideRate }]">
                            <el-input placeholder="请输入分成比例" v-model="item.platform_rate" style="width:90%;"
                            oninput="this.value=this.value.replace(/[^\d.]/g,'').replace(/(\.\d+)\.+/g, '$1').replace(/(\..*)\./g, '$1').replace(/(\.\d{2})\d+/g, '$1')">
                            <template slot="append">%</template>
                          </el-input>
                        </el-form-item>
                        <!-- 控制新增按钮和删除按钮的显示 -->
                        <div v-if="index === 0">
                          <!-- 第一行显示新增按钮 -->
                          <img @click="AddPushList"
                            style="width: 25px;height: 25px;margin-left:10px;margin-top:5px;cursor: pointer;"
                            src="@/assets/btn/xz.png" alt="">
                        </div>
                        <div v-if="index > 0">
                          <!-- 第二行及以后显示删除按钮 -->
                          <img @click="AddPushDel(index)"
                            style="width: 25px;height: 25px;margin-left:10px;margin-top:5px;cursor: pointer;"
                            src="@/assets/btn/sc.png" alt="">
                        </div>
                      </div>
                    </el-col>
                  </template>

                  <el-col v-if="currentTypeList.includes('benefit') && addForm.is_divided == 1" :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
                    <el-form-item label="分成比例"  prop="benefit" :label-width="formLabelWidthChild"
                      :rules="[
                          {required: currentTypeList.includes('benefit') && addForm.is_divided==1, message: '', trigger: 'blur', validator: validateRate2}
                        ]"
                    >
                        <el-input placeholder="请输入分成比例" v-model="addForm.benefit"
                        oninput="this.value=this.value.replace(/[^\d.]/g,'').replace(/(\.\d+)\.+/g, '$1').replace(/(\..*)\./g, '$1').replace(/(\.\d{2})\d+/g, '$1')">
                        <template slot="append">%</template>
                        </el-input>
                    </el-form-item>
                  </el-col>
                  
                  <!-- 以下： 分销分成相关项 -->
                  <el-col v-if="currentTypeList.includes('dy_ratio') && addForm.is_divided == 1" :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
                    <el-form-item label="抖小分成"  prop="dy_ratio" :label-width="formLabelWidthChild">
                        <el-input placeholder="请输入抖小分成" v-model="addForm.dy_ratio"
                        oninput="this.value=this.value.replace(/[^\d.]/g,'').replace(/(\.\d+)\.+/g, '$1').replace(/(\..*)\./g, '$1').replace(/(\.\d{2})\d+/g, '$1')">
                        <template slot="append">%</template>
                        </el-input>
                    </el-form-item>
                  </el-col>
                  <el-col v-if="currentTypeList.includes('wx_ratio') && addForm.is_divided == 1" :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
                      <el-form-item label="微小分成" prop="wx_ratio" :label-width="formLabelWidthChild">
                          <el-input placeholder="请输入微小分成" v-model="addForm.wx_ratio"
                          oninput="this.value=this.value.replace(/[^\d.]/g,'').replace(/(\.\d+)\.+/g, '$1').replace(/(\..*)\./g, '$1').replace(/(\.\d{2})\d+/g, '$1')">
                          <template slot="append">%</template>
                          </el-input>
                      </el-form-item>
                  </el-col>
                  <el-col v-if="currentTypeList.includes('ks_ratio') && addForm.is_divided == 1" :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
                    <el-form-item label="快手自建站分成"  prop="ks_ratio" :label-width="formLabelWidthChild">
                        <el-input placeholder="请输入快手自建站分成" v-model="addForm.ks_ratio"
                        oninput="this.value=this.value.replace(/[^\d.]/g,'').replace(/(\.\d+)\.+/g, '$1').replace(/(\..*)\./g, '$1').replace(/(\.\d{2})\d+/g, '$1')">
                        <template slot="append">%</template>
                        </el-input>
                    </el-form-item>
                  </el-col>
                  <!-- 以上： 分销分成相关项 -->

                  <!-- 以下： 基础分成/投流分成相关项 -->
                  <template v-if="addForm.is_divided == 1 && addForm.type != 7">
                    <el-col v-if="currentTypeList.includes('licensing_mode')" :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
                      <el-form-item label="授权模式" prop="licensing_mode" :label-width="formLabelWidthChild">
                          <el-radio-group v-model="addForm.licensing_mode" @change="licensingModeChange">
                            <el-radio label="IAP">IAP</el-radio>
                            <el-radio label="IAA">IAA</el-radio>
                            <el-radio label="BOTH">IAA+IAP</el-radio>
                          </el-radio-group>
                      </el-form-item>
                    </el-col>
                    
                    <template v-if="addForm.is_divided == 1 && currentTypeList.includes('recharge_ratio') && (addForm.licensing_mode == 'IAP' || addForm.licensing_mode == 'BOTH')">
                      <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
                        <el-form-item label="IAP"  prop="recharge_ratio" :label-width="formLabelWidthChild">
                            <el-col v-if="currentTypeList.includes('recharge_ratio')" :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
                              <el-form-item label="充值流水分成"  prop="recharge_ratio" :label-width="formLabelWidthChildThree" style="width:100%">
                                  <el-input placeholder="请输入充值流水分成" v-model="addForm.recharge_ratio"
                                  oninput="this.value=this.value.replace(/[^\d.]/g,'').replace(/(\.\d+)\.+/g, '$1').replace(/(\..*)\./g, '$1').replace(/(\.\d{2})\d+/g, '$1')">
                                  <template slot="append">%</template>
                                  </el-input>
                              </el-form-item>
                            </el-col>
                            <el-col v-if="currentTypeList.includes('net_ratio')" :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
                                <el-form-item label="净利润分成" prop="net_ratio" :label-width="formLabelWidthChildThree" style="width:100%">
                                    <el-input placeholder="请输入净利润分成" v-model="addForm.net_ratio"
                                    oninput="this.value=this.value.replace(/[^\d.]/g,'').replace(/(\.\d+)\.+/g, '$1').replace(/(\..*)\./g, '$1').replace(/(\.\d{2})\d+/g, '$1')">
                                    <template slot="append">%</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col v-if="currentTypeList.includes('authorize_platform')" :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
                                <el-form-item label="授权平台" :label-width="formLabelWidthChildThree" style="width:100%">
                                    <SelectChecked ref="SelectChecked3" :options="authOptionsA" placeholder="请选择平台" :isRemoveAllTag="isRemoveAllTag"
                                        @selectedVal="selectedReferralAuth" />
                                </el-form-item>
                            </el-col>
                        </el-form-item>
                      </el-col>
                    </template>

                    <template v-if="addForm.is_divided == 1 && currentTypeList.includes('recharge_ratio') && (addForm.licensing_mode == 'IAA' || addForm.licensing_mode == 'BOTH')">
                      <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
                        <el-form-item label="IAA"  prop="recharge_ratio_iaa" :label-width="formLabelWidthChild">
                            <el-col v-if="currentTypeList.includes('recharge_ratio_iaa')" :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
                              <el-form-item label="充值流水分成"  prop="recharge_ratio_iaa" :label-width="formLabelWidthChildThree" style="width:100%">
                                  <el-input placeholder="请输入充值流水分成" v-model="addForm.recharge_ratio_iaa"
                                  oninput="this.value=this.value.replace(/[^\d.]/g,'').replace(/(\.\d+)\.+/g, '$1').replace(/(\..*)\./g, '$1').replace(/(\.\d{2})\d+/g, '$1')">
                                  <template slot="append">%</template>
                                  </el-input>
                              </el-form-item>
                            </el-col>
                            <el-col v-if="currentTypeList.includes('net_ratio_iaa')" :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
                                <el-form-item label="净利润分成" prop="net_ratio_iaa" :label-width="formLabelWidthChildThree" style="width:100%">
                                    <el-input placeholder="请输入净利润分成" v-model="addForm.net_ratio_iaa"
                                    oninput="this.value=this.value.replace(/[^\d.]/g,'').replace(/(\.\d+)\.+/g, '$1').replace(/(\..*)\./g, '$1').replace(/(\.\d{2})\d+/g, '$1')">
                                    <template slot="append">%</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col v-if="currentTypeList.includes('authorize_platform_iaa')" :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
                                <el-form-item label="授权平台" :label-width="formLabelWidthChildThree" style="width:100%">
                                    <SelectChecked ref="SelectChecked4" :options="authOptionsB" placeholder="请选择平台" :isRemoveAllTag="isRemoveAllTag"
                                        @selectedVal="selectedReferralAuthIAA" />
                                </el-form-item>
                            </el-col>
                        </el-form-item>
                      </el-col>
                    </template>

                  </template>
                  <!-- 以上： 基础分成/投流分成相关项 -->

                  <!-- type为 7 时，单独展示这个平台选择 -->
                  <el-col v-if="addForm.type == 7 && currentTypeList.includes('authorize_platform')" :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
                    <el-form-item label="发行权益" :label-width="formLabelWidthChild">
                        <SelectChecked ref="SelectChecked5" :options="authOptionsA" placeholder="请选择平台" :isRemoveAllTag="isRemoveAllTag"
                            @selectedVal="selectedReferralAuth" />
                    </el-form-item>
                  </el-col>

                  <el-col v-if="currentTypeList.includes('divided_start_date') && addForm.is_divided == 1" :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
                      <el-form-item label="分成周期"  prop="divided_start_date" :label-width="formLabelWidthChild" >
                          <el-date-picker
                              v-model="dividedDate"
                              type="daterange"
                              align="right"
                              unlink-panels
                              start-placeholder="开始时间"
                              end-placeholder="结束时间"
								              value-format="yyyy-MM-dd"
                              @change="handTimeZhuce($event,'dividedDate')"
                              style="width: 100%;">
                          </el-date-picker>
                      </el-form-item>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="签订时间" prop="signed_date" :label-width="formLabelWidth">
                <el-date-picker
                    v-model="addForm.signed_date"
                    type="date"
                    placeholder="选择签订时间"
                    value-format="yyyy-MM-dd"
                    style="width: 85%;">
                </el-date-picker>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="生效时间" prop="validity_start"  :label-width="formLabelWidth">
                <el-date-picker
                    v-model="validityData"
                    type="daterange"
                    align="right"
                    unlink-panels
                    start-placeholder="开始时间"
                    end-placeholder="结束时间"
                    @change="handTimeZhuce($event,'validityData')"
								    value-format="yyyy-MM-dd"
                    :picker-options="pickerOptions"
                    style="width: 85%;">
                </el-date-picker>
              </el-form-item>
            </el-col>

            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="状态" prop="status" :label-width="formLabelWidth" style="width: 85%;">
                <el-radio-group v-model="addForm.status">
                  <el-radio :label="1">正常</el-radio>
                  <el-radio :label="0">禁用</el-radio>
                </el-radio-group>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" class="mb20">
              <el-form-item label="合作事项" prop="contents" :label-width="formLabelWidth">
                <el-input type="textarea"  v-model="addForm.contents" autosize placeholder="请输入合作事项" clearable style="width: 85%;"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="demo-drawer__footer">
        <el-button @click="AddNone">取 消</el-button>
        <el-button type="primary" @click="addPush">确 定</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import {MoneyManagementAPI} from '@/api/MoneyManagement/MoneyManagement';
import {processErrors} from "@/utils/errorHandler";
import SelectChecked from '@/components/Select/SelectChecked.vue';

export default {
  props: ['AddContractFlag', "editID","typeOptions"],
  components: {
    SelectChecked
  },
  data() {
    // 表单校验规则-百分比
    var validateRate = (rule, value, callback) => {
      if ((value  &&  (value >  100 || value < 0.01)) && value != 0.00) {
        return callback(new Error('比例在 0.01 ~ 100 之间'));
      }else{
        return callback();
      }
    };
    // 表单校验规则-上传文件
    var validatePloadFile = (rule, value, callback) => {
      if (value == 1) {
        return callback();
      }else{
        return callback(new Error('请选择合同上传'));
      }
    };
    
    return {
      // 公共表单项，表单提交的基础(公共)参数
      addFormBasicKey: ['id','code','name','a_subject_id','b_subject_id','type','files','signed_date','validity_start','validity_end','status','contents','licensing_area','licensing_area_describe'],
      // 当前合同类型对应的列表项集合
      currentTypeList:[],
      // 合同类型对应展示的表单项，key值和typeOptions中的value值一一对应
      mapTypeList:{
        1:['amount', 'is_divided', 'short_play_project_id', 'licensing_mode', 'recharge_ratio','net_ratio','authorize_platform','recharge_ratio_iaa','net_ratio_iaa','authorize_platform_iaa','divided_start_date','divided_end_date' ],
        2:['amount', 'is_divided', 'short_play_project_id', 'licensing_mode', 'recharge_ratio','net_ratio','authorize_platform','recharge_ratio_iaa','net_ratio_iaa','authorize_platform_iaa','divided_start_date','divided_end_date' ],
        3:['amount', 'is_divided', 'short_play_project_id', 'licensing_mode', 'recharge_ratio','net_ratio','authorize_platform','recharge_ratio_iaa','net_ratio_iaa','authorize_platform_iaa','divided_start_date','divided_end_date' ],
        4:['amount', 'is_divided', 'short_play_project_id', 'initial_amount' ,'final_amount','divided_type'],
        5:['amount', 'is_divided', 'short_play_project_id', 'licensing_mode', 'initial_amount', 'middle_amount', 'final_amount','recharge_ratio','net_ratio','authorize_platform','recharge_ratio_iaa','net_ratio_iaa','authorize_platform_iaa','divided_start_date','divided_end_date'],
        6:['amount', 'short_play_project_id', 'real_amount', 'benefit', 'divided_start_date','divided_end_date'],
        7:['amount', 'short_play_project_id', 'real_amount','benefit','divided_start_date','divided_end_date','authorize_platform'],
        8:['amount', 'is_divided', 'authorize_object', 'dy_ratio','wx_ratio','ks_ratio','divided_start_date','divided_end_date'],
        9:['amount', 'is_divided', 'licensing_mode', 'recharge_ratio','net_ratio','authorize_platform','recharge_ratio_iaa','net_ratio_iaa','authorize_platform_iaa'],
      },


      title: "新增",
      formLabelWidth: "140px", 
      formLabelWidthChild: "110px", //二级子级宽度
      formLabelWidthChildThree: "100px", //三级子级宽度
      addForm: {
        code: "",
        name: "",
        a_subject_id: "",
        b_subject_id: "",
        type: "",
        signed_date: "",
        status: 1,
        uploadFile:'',
        is_divided: 1,
        contents:'',
        licensing_area:'',
        licensing_area_describe:'',
        licensing_mode: '',
        amount:"",
        short_play_project_id: "",
        initial_amount: "",
        final_amount: "",
        divided_type: "",
        middle_amount: "",
        real_amount: "",
        benefit: "",
        divided_start_date: "",
        divided_end_date: "",
        recharge_ratio: "",
        net_ratio: "",
        authorize_platform:'',
        recharge_ratio_iaa: "",
        net_ratio_iaa: "",
        authorize_platform_iaa:'',
        authorize_object:'',
        dy_ratio: '',
        wx_ratio: '',
        ks_ratio: '',
        platformArray: [],
      }, 
      rules: {
        recharge_ratio:[{
          trigger: 'blur', validator: validateRate,
        }],
        net_ratio:[{
          trigger: 'blur', validator: validateRate,
        }],
        dy_ratio:[{
          trigger: 'blur', validator: validateRate,
        }],
        wx_ratio:[{
          trigger: 'blur', validator: validateRate,
        }],
        ks_ratio:[{
          trigger: 'blur', validator: validateRate,
        }],
        code: [
          {required: true, message: '请输入合同编号', trigger: 'blur'},
        ],
        name: [
          {required: true, message: '请输入合同名称', trigger: 'blur'},
        ],
        a_subject_id: [
          {required: true, message: '请选择甲方主体公司', trigger: 'change'}
        ],
        b_subject_id: [
          {required: true, message: '请选择乙方主体公司', trigger: 'change'}
        ],
        type: [
          {required: true, message: '请选择合同类型', trigger: 'change'}
        ],
        signed_date: [
          {required: true, message: '请选择签订时间', trigger: 'change'}
        ],
        validity_start: [
          {required: true, message: '', trigger: 'change',validator: this.validateDateRage,}
        ],
        status: [
          {required: true, message: '请选择状态', trigger: 'change'}
        ],
        uploadFile: [
          {required: true, message: '', trigger: 'change', validator: validatePloadFile}
        ],
        amount: [
          {required: true, message: '', trigger: 'change',validator: this.validateAmount}
        ],
        is_divided: [
          {required: true, message: '请选择是否涉及分成', trigger: 'change'}
        ],
      },
      
      subjectListA: [], // 甲方主体公司列表
      subjectListB: [], // 乙方主体公司列表
      projectList:[], // 项目列表
      authOptionsA: [], // 授权平台列表(iap 及 发行)
      authOptionsB: [], // 授权平台列表 Iaa
      fileList: [], // 上传文件列表
      myLimit: 3, // 上传文件数量限制
      isRemoveAllTag: 0,
      validityData: [], // 生效时间
      dividedDate: [], // 分成周期
      project_name:'', // 项目名称
      currentItem:{}, // 项目列表当前选择的项目
      pickerOptions: { // 生效时间选择器配置
        shortcuts: [ {
          text: '永久',
          onClick(picker) {
            const now = new Date();
            const end = new Date(now.getFullYear() + 1000, now.getMonth(), now.getDate())
            const start = new Date();
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      licensingAreaList:[ // 授权范围列表
        {id: '1', name: '全球'},
        {id: '2', name: '全国'},
        {id: '3', name: '内地'},
        {id: '4', name: '海外'},
      ],
    };
  },
  computed:{
    // 计算amount表单项的label
    amountName(){
      let name = ''
      switch (this.addForm.type) {
        case 1:
        case 2:
        case 3:
        case 8:
          name = '保底金额';
          break;
        case 4:
        case 5:
          name =  '总计金额';
          break;
        case 6:
          name =  '投资金额';
          break;
        case 7:
          name =  '项目成本';
          break;
        case 9:
          name =  '合同金额';
          break;
        default:
          name =  '金额';
          break
      }
      return this.addForm.type ? name : '金额'
    }
  },
  watch:{
    AddContractFlag(newValue){
      if(newValue){
        if (this.editID != "" && this.editID) {
          this.title = "编辑"
          let api = MoneyManagementAPI()
          api.contractInfo(this.editID).then(res => {
            if (res.code == 0) {
              this.title = "编辑"
              this.addForm = JSON.parse(JSON.stringify(res.data))
              this.updateAuthOptions()
              this.getSubjectSelect()
              this.typeChange(res.data.type,true)
              // 更新时间范围选择器
              this.validityData = JSON.parse(JSON.stringify([res.data.validity_start, res.data.validity_end]))
              this.dividedDate = JSON.parse(JSON.stringify(res.data.divided_start_date && res.data.divided_start_date!='0000-00-00' ? [res.data.divided_start_date, res.data.divided_end_date] : []))
              // 获取上传文件列表
              if(res.data.files && res.data.files.length>0){
                this.fileList = res.data.files.map((item,index) => {
                  return {
                    index,
                    status: 'success',
                    ...item
                  }
                })
                this.addForm.uploadFile = 1
              }else{
                this.addForm.uploadFile = ''
              }
              // 回显：剧本-平台分成-分成列表
              if(res.data.divided_platform_detail){
                this.$set(this.addForm,'platformArray',res.data.divided_platform_detail)
              }
              res.data.divided_type == 0 ? this.addForm.divided_type = '' : ''

              this.$nextTick(()=>{
                // 更新子级列表
                res.data.authorize_platform && this.updateAuthOptions(res.data.authorize_platform)
                this.getProjectSelect()
              })              
            } else {
              processErrors(res);
            }
          })
        }else{
          this.title = "新增"
          this.getSubjectSelect()
          this.getProjectSelect()
          this.updateAuthOptions()
          this.$refs['ruleForm'] && this.$refs['ruleForm'].resetFields();
        }
      }else{
        this.initForm()
      }
    }
  },
  methods: {
    // 表单校验规则-上传文件
    validateProject (rule, value, callback){
      if(this.currentTypeList.includes('short_play_project_id')){
        setTimeout(() => {
          if (!this.addForm.short_play_project_id) {
            return callback(new Error('请选择项目'));
          }else{
            if (Object.keys(this.currentItem).length === 0) {
              return callback(new Error('请在下拉列表中选择项目'));
            }else{
              return callback();
            }
          }
        },500);
      }else{
        return callback();
      }
    },
    // 表单校验规则-生效时间
    validateDateRage(rule, value, callback) {
      if (this.validityData && this.validityData.length>0 && this.validityData[0]!='') {
        return callback();
      }else{
        return callback(new Error('请选择生效时间'));
      }
    },
    // 表单校验规则-分成比例-type 4
    validateDivideRate (rule, value, callback) {
      if(this.currentTypeList.includes('platformArray')){
        const field = rule.field.split('.')[1]
        const val = this.addForm.platformArray[field].platform_rate
        if(!val){
          return callback(new Error('请输入分成比例'));
        }else if ( val >  100 || val < 0.01) {
          return callback(new Error('比例在 0.01 ~ 100 之间'));
        }else{
          return callback();
        }
      }else{
        return callback();
      }
    },
    // 表单校验规则-平台名称-type 4
    validatePlatForm (rule, value, callback) {
      if(this.currentTypeList.includes('platformArray')){
        const field = rule.field.split('.')[1]
        const val = this.addForm.platformArray[field].platform_name
        if(!val){
          return callback(new Error('请输入平台名称'));
        }else{
          return callback();
        }
      }else{
        return callback();
      }
    },
    // 表单校验规则-金额
    validateAmount(rule, value, callback) {
        if(!value){
          return callback(new Error('请输入金额'));
        }else{
          return callback();
        }
    },
    // 表单校验规则-分成比例-type 6,7
    validateRate2(rule, value, callback) {
      if(!value){
        return callback(new Error('请输入分成比例'));
      }else if ((value  &&  (value >  100 || value < 0.01)) && value != 0.00) {
        return callback(new Error('比例在 0.01 ~ 100 之间'));
      }else{
        return callback();
      }
    },
    /**
     * 把a中的数据更新到b中，并不新增b的属性
     * a,b都得传对象
     */
    updateObject(a, b) {
      Object.keys(b).forEach(key => {
        if (a.hasOwnProperty(key)) {
          b[key] = a[key];
        }
      });
    },
    /**删除addform中多余属性，确保数据准确性 */
    deleteRedundantKey(obj) {
      // 拿到需要上传参数的键值对
      const list = [...this.addFormBasicKey, ...this.currentTypeList];

      let addFormKeyList = Object.keys(this.addForm);
      let keysToDelete = addFormKeyList.filter(key => list.includes(key));
      return keysToDelete.reduce((res, key) => {
        res[key] = obj[key] == null || obj[key] == undefined ? '' : obj[key];
        return res;
      }, {});
    },
    /**获取主体公司列表 */
    getSubjectSelect() {
      let api = MoneyManagementAPI()
      api.getSubjectSelect().then(res => {
        if (res.code == 0) {
          let list = JSON.parse(JSON.stringify(res.data))
          list.map(item=>{
            item.label = item.name
            item.value = item.id
            item.check = false
          })
          this.subjectListA = JSON.parse(JSON.stringify(list))
          this.subjectListB = JSON.parse(JSON.stringify(list))

          // 如果刷新前有数据，保持选中状态
          if (this.addForm.a_subject_id) {
            this.subjectListA = this.subjectListA.map(item => {
              return {
                ...item,
                check: this.addForm.a_subject_id.split(',').includes(String(item.value))
              };
            });
          }
          if (this.addForm.b_subject_id) {
            this.subjectListB = this.subjectListB.map(item => {
              return {
                ...item,
                check: this.addForm.b_subject_id.split(',').includes(String(item.value))
              };
            });
          }
        } else {
          processErrors(res);
        }
      })
    },
    /**更新项目列表 */
    getProjectSelect() {
      let api = MoneyManagementAPI()
      api.getShortPlayProjectList({pageNo: 1, pageSize: 99999}).then(res => {
        if (res.code == 0) {
          let list = res.data.data
          this.projectList = JSON.parse(JSON.stringify(list))
          if (this.addForm.short_play_project_id) {
            // 如果刷新前有数据，保持选中状态
            const current = list.find(item => item.id == this.addForm.short_play_project_id)
            this.project_name = current.name
            this.currentItem = current
          }else{
            // 如果刷新前无数据，清空状态
            this.project_name = ''
            this.currentItem = {}
          }
        } else {
          processErrors(res);
        }
      })
    },
    /**更新授权平台列表 */
    updateAuthOptions(){
      let api = MoneyManagementAPI()
      api.getAuthPlatformSelect().then(res=>{
        let resultList = []
        res.data.forEach(item=>{
          resultList.push({
            value: item.id,
            label: item.name,
            check: false
          })
        })
        this.authOptionsA = JSON.parse(JSON.stringify(resultList))
        this.authOptionsB = JSON.parse(JSON.stringify(resultList))

        if(this.addForm.authorize_platform){
          let str = this.addForm.authorize_platform
          // 如果刷新前有数据，保持选中状态
          this.authOptionsA = resultList.map(item => {
            return {
              ...item,
              check: str.split(',').includes(String(item.value))
            };
          });
        }
        if(this.addForm.authorize_platform_iaa){
          let str = this.addForm.authorize_platform_iaa
          // 如果刷新前有数据，保持选中状态
          this.authOptionsB = resultList.map(item => {
            return {
              ...item,
              check: str.split(',').includes(String(item.value))
            };
          });
        }
      })
    },
    /**时间单位选择器change事件——更新相关值 */
    handTimeZhuce(e,type) {
      const formattedDate = e ? e[0] : '';
      const formattedDates = e ? e[1] : '';

      switch (type) {
        case 'validityData':
          this.addForm.validity_start = formattedDate;
          this.addForm.validity_end = formattedDates;
          this.$set(this, "validityData", [formattedDate,formattedDates]);
          break;
        case 'dividedDate':
          this.addForm.divided_start_date = formattedDate;
          this.addForm.divided_end_date = formattedDates;
          this.$set(this, "dividedDate", [formattedDate,formattedDates]);
          break;
        default:
          break;
      }
      
    },
    handleRemove(file, fileList) {
      if(file && file.status == 'success'){
        // 只用判断成功状态的数据
        const i = this.fileList.findIndex(item=>item.index == file.index);
        i !=-1 ? this.fileList.splice(i, 1) : ''
                
        if(this.fileList.length==0)this.addForm.uploadFile = ''
      }
    },

    handlePreview(e) {
     let url = this.fileList[e.index].url_full
      window.open(url, '_blank'); // '_blank' 表示在新标签页中打开
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 ${this.myLimit} 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },

    beforeRemove(file, fileList) {
      if(file && file.status == 'success'){
        // 只有成功状态的数据才用提示卡他
        return this.$confirm(`确定移除 ${file.name}？`);
      }
    },

    httpRequest(file) {
      let fileUpload = new FormData();
      fileUpload.append("file", file.file);
      this.toUploadFile(fileUpload,file.file);
    },

    toUploadFile(fileUpload, file) {
      let api = MoneyManagementAPI();

      api.fileContractUpload(fileUpload).then((res) => {
        if (res.code == 0) {
          this.fileList.push({
            name: file.name,
            index: this.fileList.length,
            ...res.data,
            url: res.data.url,
            url_full: res.data.url_full,
            status: 'success', //手动添加文件状态
          })
          this.addForm.uploadFile = 1
        } else {
          processErrors(res);
        }
      });
    },
    /**上传之前大小 */
    beforeAvatarUpload(file){
      const isSize0 = file.size != 0;
      if (!isSize0) {
        this.$message.error('上传文件大小不能为 0 !');
      }
      const isLt2M = file.size / 1024 / 1024 < 100;
      if (!isLt2M) {
        this.$message.error('上传文件大小不能超过 100MB !');
      }
      return isSize0 && isLt2M;
    },
    /**初始化数据 */
    initForm(){
      this.title = ""
      this.addForm = {
        code: "",
        name: "",
        a_subject_id: "",
        b_subject_id: "",
        type: "",
        signed_date: "",
        status: 1,
        uploadFile:'',
        is_divided: 1,
        contents:'',
        licensing_area:'',
        licensing_area_describe:'',
        licensing_mode: '',
        amount:"",
        short_play_project_id: "",
        initial_amount: "",
        final_amount: "",
        divided_type: "",
        middle_amount: "",
        real_amount: "",
        benefit: "",
        divided_start_date: "",
        divided_end_date: "",
        recharge_ratio: "",
        net_ratio: "",
        authorize_platform:'',
        recharge_ratio_iaa: "",
        net_ratio_iaa: "",
        authorize_platform_iaa:'',
        authorize_object:'',
        dy_ratio: '',
        wx_ratio: '',
        ks_ratio: '',
      }
      // 初始化上传列表
      this.fileList = []
      // 初始化日期范围选择器
      this.validityData = []
      this.dividedDate = []
      // 初始化多选项
      const selectedReferralInitList = ['SelectChecked1','SelectChecked2','SelectChecked3','SelectChecked4','SelectChecked5']
      selectedReferralInitList.forEach(item => {
        const dom = this.$refs[item]
        dom && dom.removeTag()
      })
      // 重置表单校验
      this.$refs['ruleForm'].resetFields();
    },

    AddNone() {
      this.$emit('NoneDlog');
    },

    addPush() {
      // 刷新上传文件状态，精准校验
      this.addForm.uploadFile = this.fileList.length>0 ? 1 : ''
      console.log(this.addForm,'校验前')
      this.$refs['ruleForm'].validate((valid,e) => {
        console.log(valid,e,'校验结果')
        if (valid) {
          let createText = ''
          if (!this.addForm.id || this.addForm.id == "") {
            createText = "创建成功";
          } else {
            createText = "修改成功";
          }
          // /** 规范文件上传的格式*/
          if (this.fileList.length > 0) {
            let queryFiles = []
            this.fileList.forEach(item => {
              queryFiles.push({
                name: item.name,
                url: item.url,
              })
            })
            this.addForm.files = JSON.stringify(queryFiles);
          }else{
            this.addForm.files = [];
          }
          
          // /** 处理分成相关数据*/
          if(!this.checkDivided()){
            return
          }
          // /** 规范接口传参,不传多余参数 */
          this.addForm = this.deleteRedundantKey(this.addForm)
          
          // /** 补充不展示但需要传参的数据 */
          // 处理授权某方平台
          if(this.addForm.type == 1 ){
            this.addForm.authorize_object = 1
          }else if(this.addForm.type == 2 || this.addForm.type == 3 ){
            this.addForm.authorize_object = 2
          }
          // 处理分成类型
          if(this.addForm.is_divided == 1){
            const judgeType = [1,2,3,5,8,9]
            if(judgeType.includes(this.addForm.type)){
              this.addForm.divided_type = 1
            }
          }
          // 处理是否分成
          if(this.addForm.type == 6 || this.addForm.type == 7 ){
            this.addForm.is_divided = 1
          }
          let api = MoneyManagementAPI()
          api.contractAdded(this.addForm).then(res => {
            if (res.code == 0) {
              this.$message({
                message: createText,
                type: 'success'
              });
              this.$emit('AddOk');
            } else {
              processErrors(res);
            }
          })
        } else {
          return false;
        }
      });
    },
    /**添加下拉项，
     * @param type 传pro则跳转小说项目页，否则跳主体页 */
    AddPushSubjec(type) {
      const baseExportUrl = new URL(window.location.href).origin;
        let target = type == 'pro' ? '/#/MoneyManagement/ShortPlayProject' : '/#/MoneyManagement/subject'
        let url = baseExportUrl + target;
        window.open(url);
    },
    AddRefreshSubjec(){
      this.getSubjectSelect();
    },
    selectedReferralA(value) {
      this.addForm.a_subject_id = value.join(',');
    },
    selectedReferralB(value) {
      this.addForm.b_subject_id = value.join(',');
    },
    selectedReferralAuth(value) {
      this.addForm.authorize_platform = value.join(',');
    },
    selectedReferralAuthIAA(value) {
      this.addForm.authorize_platform_iaa = value.join(',');
    },
    selectedReferralProject(value) {
      this.addForm.short_play_project_id = value.join(',');
    },
    querySearch(queryString, cb) {
      if(!queryString ||  this.currentItem?.name != queryString){
        this.currentItem = {}
        var restaurants = this.projectList;
        var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
        // 调用 callback 返回建议列表的数据
        cb(results);
      }else{
        cb(this.projectList);
      }
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (restaurant.name ? restaurant.name.indexOf(queryString) === 0 : false);
      };
    },
    handleSelect(item) {
      this.project_name = item.name
      this.addForm.short_play_project_id = item.id
      this.currentItem = item
    },
    /**切换合同类型 - 更新当前子级表单 */
    typeChange(e,type){
      this.currentTypeList = this.mapTypeList[e]

      // 切换合作类型时，重置授权平台下拉
      let initSelect = ['SelectChecked3','SelectChecked4','SelectChecked5']
      initSelect.forEach(item => {
        const dom = this.$refs[item]
        dom && dom.removeTag()
      })      

      // 类型为4时单独处理
      e == 4 && this.typeChangeBy4()

      // 给是否分成设置初始值
      if(!type){
        // 正常切换
        // 切换合同类型，is_divided默认为是, 授权模式默认IAP
        this.addForm.is_divided = 1
        this.addForm.licensing_mode = 'IAP'
      }else{
        // 编辑赋值时走这里
        // 这两个平台默认就是分成
        if(this.addForm.type == 6 || this.addForm.type == 7 ){
          this.addForm.is_divided = 1
        }
      }
    },
    /** 处理分成相关数据*/
    checkDivided(){
      if(this.currentTypeList.includes('is_divided')){
        // 不涉及分成
        if(this.addForm.is_divided == 0){
          // 清空分成比例
          if(this.addForm.type == 8){
            this.addForm.dy_ratio = 0
            this.addForm.wx_ratio = 0
            this.addForm.ks_ratio = 0
          }else if(this.addForm.type == 6 || this.addForm.type == 7){
            this.addForm.benefit = 0
          }else{
            this.addForm.platformArray = []
            this.addForm.divided_platform_detail = ''
            this.addForm.recharge_ratio = 0
            this.addForm.net_ratio = 0
            this.addForm.recharge_ratio_iaa = 0
            this.addForm.net_ratio_iaa = 0
          }
          // 清空分成周期
          this.dividedDate = []
          this.addForm.divided_end_date = ''
          this.addForm.divided_start_date = ''
        }else {
          // 涉及分成
          if(this.addForm.type == 4 ){
            if(this.addForm.divided_type == 2){
              let arr = JSON.parse(JSON.stringify(this.addForm.platformArray ? this.addForm.platformArray : []))
              this.addForm.divided_platform_detail = JSON.stringify(arr)
              return true
            }else{
              // 当模式为IAP 或 BOTH时，校验IAP相关参数
              if( this.addForm.licensing_mode == 'IAP'|| this.addForm.licensing_mode == 'BOTH' ){
                // 判断是否两项都为空
                if(this.checkoutZero(this.addForm.recharge_ratio) && this.checkoutZero(this.addForm.net_ratio)){
                  this.$message.error('【IAP分成比例】至少需要填一项且不为0');
                  return false
                }
              }

              // 当模式为IAA 或 BOTH时，校验IAP相关参数
              if( this.addForm.licensing_mode == 'IAA'|| this.addForm.licensing_mode == 'BOTH' ){
                // 判断是否两项都为空
                if(this.checkoutZero(this.addForm.recharge_ratio_iaa) && this.checkoutZero(this.addForm.net_ratio_iaa)){
                  this.$message.error('【IAA分成比例】至少需要填一项且不为0');
                  return false
                }
              }
              this.addForm.divided_platform_detail = ''
              return true
            }
          }else if(this.addForm.type == 8){
            if(this.checkoutZero(this.addForm.dy_ratio) && this.checkoutZero(this.addForm.wx_ratio) && this.checkoutZero(this.addForm.ks_ratio)){
              this.$message.error('【分成比例】至少需要填一项且不为0');
              return false
            }
          }else if(this.addForm.type == 6 || this.addForm.type == 7){
            return true
          }else {
            // 当模式为IAP 或 BOTH时，校验IAP相关参数
            if( this.addForm.licensing_mode == 'IAP'|| this.addForm.licensing_mode == 'BOTH' ){
              // 判断是否两项都为空
              if(this.checkoutZero(this.addForm.recharge_ratio) && this.checkoutZero(this.addForm.net_ratio)){
                this.$message.error('【IAP分成比例】至少需要填一项且不为0');
                return false
              }
            }

            // 当模式为IAA 或 BOTH时，校验IAP相关参数
            if( this.addForm.licensing_mode == 'IAA'|| this.addForm.licensing_mode == 'BOTH' ){
              // 判断是否两项都为空
              if(this.checkoutZero(this.addForm.recharge_ratio_iaa) && this.checkoutZero(this.addForm.net_ratio_iaa)){
                this.$message.error('【IAA分成比例】至少需要填一项且不为0');
                return false
              }
            }
          }
        }
      }
      return true
    },
    checkoutZero(val){
      return !val || val==0 || val==0.00
    },
    handleChangeChildType(){
      this.typeChangeBy4()
    },
    /**处理合同类型为 4 的展示项 */
    typeChangeBy4(){
      if(this.addForm.type == 4){
        // 判断是否涉及分成
        if(this.addForm.is_divided == 1){
          // 涉及分成
          // 给分成类型设默认值
          !this.addForm.divided_type ? this.addForm.divided_type = 1 : ''
          if(this.addForm.divided_type == 1){
            // 投流分成  展示批量填写平台及对应分成比例
            this.currentTypeList.push('licensing_mode','recharge_ratio','net_ratio','authorize_platform','recharge_ratio_iaa','net_ratio_iaa','authorize_platform_iaa')
            this.currentTypeList = this.currentTypeList.filter(item => item !== 'platformArray' && item !== 'divided_platform_detail');
          }else if(this.addForm.divided_type == 2){
            // 平台分成  展示基础的充值和净利润分成
            this.currentTypeList.push('platformArray', 'divided_platform_detail')
            const notShow = ['licensing_mode','recharge_ratio','net_ratio','authorize_platform','recharge_ratio_iaa','net_ratio_iaa','authorize_platform_iaa']
            this.currentTypeList = this.currentTypeList.filter(item => !notShow.includes(item));
            // 更新分成类型列表
            const list = this.addForm.platformArray && this.addForm.platformArray.length>0 ? this.addForm.platformArray : [{platform_name:'', platform_rate:''}]
            this.$set(this.addForm,'platformArray', list)
            this.licensingModeChange()
          }
        }else{
          // 不涉及分成的，加上这些字段，this.checkDivided会把他们初始化
          this.currentTypeList.push('recharge_ratio','net_ratio','platformArray','authorize_platform','recharge_ratio_iaa','net_ratio_iaa','authorize_platform_iaa', 'divided_platform_detail')
        }
      }
    },
    AddPushList() {
      // 向表单项数组中添加一个新的表单对象
      this.addForm.platformArray.push({ platform_name: '', platform_rate: '' });
    },
    AddPushDel(index) {
      // 确保删除操作是合法的（防止删除第一行）
      if (this.addForm.platformArray.length > 1) {
        // 移除指定项
        this.addForm.platformArray.splice(index, 1);
      } else {
        this.$message.warning('至少保留一行数据');
      }
    },
    licensingModeChange(e){
      // 切换合作类型时，重置授权平台下拉
      let initSelect = ['SelectChecked3','SelectChecked4']
      initSelect.forEach(item => {
        const dom = this.$refs[item]
        dom && dom.removeTag()
      })      
      // if(e == 'IAP'){
        this.addForm.recharge_ratio_iaa = ''
        this.addForm.net_ratio_iaa = ''
        this.addForm.authorize_platform_iaa = ''
      // }else if(e == 'IAA'){ 
        this.addForm.recharge_ratio = ''
        this.addForm.net_ratio = ''
        this.addForm.authorize_platform = ''
      // }
    }
  },
}
</script>
<style lang='scss' scoped>
.demo-drawer__content {
  height: calc(100% - 80px); /* 给内容区域设置高度,留出按钮区域 */
  overflow-y: auto; /* 添加垂直滚动条 */
  margin-top: 20px;
  overflow-x: hidden;
}

.form-wrapper {
  padding-bottom: 80px; /* 给表单内容添加底部间距,留出按钮区域 */
}

.demo-drawer__footer {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 10px;
  text-align: center;
}

.demo-drawer__footer .el-button {
  margin: 0 10px;
  width: calc(50% - 20px);
}

::v-deep .el-drawer__close-btn {
  font-size: 30px;
  font-weight: bold;
}
.child{
  ::v-deep .el-form-item{
    width: 85%;
  }
}

::v-deep .el-radio input[aria-hidden="true"] {
  display: none !important;
}

::v-deep .el-radio:focus:not(.is-focus):not(:active):not(.is-disabled) .el-radio__inner {
  box-shadow: none !important;
}

::v-deep .el-range-editor .el-range-input{
  color: #606266 !important;
}

</style>